import { render, staticRenderFns } from "./AdminClubInfo.vue?vue&type=template&id=a2955d3a&scoped=true"
import script from "./AdminClubInfo.vue?vue&type=script&lang=js"
export * from "./AdminClubInfo.vue?vue&type=script&lang=js"
import style0 from "./AdminClubInfo.vue?vue&type=style&index=0&id=a2955d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2955d3a",
  null
  
)

export default component.exports